module.exports = __webpack_public_path__ + "img/jxs.3b414195.png";